module.exports = __webpack_public_path__ + "a7a5f9f1ff68e721572863ab2761e6e1.svg";